import * as types from '../types';

import * as Constants from '../utils/Constants';

const INITIAL_STATE = {
    recNewsInfo: true,
    invByEmail: true,
    reminder: Constants.EVERY_WEEK,
    customReminderDays: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SETTINGS_UPDATE_STATE:
            return { ...state, ...action.payload };
        case types.SETTINGS_RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
